const transferTypes: Record<string, string> = {
    // TYPES FOR TRANSFERS NORMAL
    "TRANSFER": "Transferencia",

    // FORM FROM_WALLET_ID NULL
    "SEASONAL_PAYMENT": "Pago de temporada",

    // FORM TO_WALLET_ID NULL
    "CHANGE_PLAYER_NICKNAME": "Cambio de nickname",
    "UPDATE_TEAM_DATA": "Actualización de la información del equipo",
    "UPDATE_TEAM_LOGO": "Actualización del logo del equipo",
    "CONTRACT_CREATED": "Creación de contrato",
    "ANNOUNCEMENT_CREATED": "Creación de un anuncio en el chat",
}

export default transferTypes;